// extracted by mini-css-extract-plugin
module.exports = {"container":"apptitle_container__2zubQ","appIcon":"apptitle_appIcon__2mm17","appName":"apptitle_appName__deVle"};